<h1 mat-dialog-title>Modifier le temps passé</h1>
<div mat-dialog-content>
  <form [formGroup]="form" class="form">
    <mat-form-field class="startDayTime-field">
      <mat-label>Temps passé</mat-label>
      <input type="time" matInput formControlName="timeSpent">
    </mat-form-field>

    <div class="actions">
      <button class="Confirmbutton" mat-raised-button color="primary" type="button" (click)="confirm()"
        [disabled]="form.pristine">Valider</button>
      <button class="button" mat-raised-button color="primary" type="button" (click)="onNoClick()">Annuler</button>
    </div>

  </form>
</div>